import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, resolveAll } from '../../../../helpers/LinkMapper';
import TransactionHistoryRange from './TransactionHistoryRange';
import DailyTransaction from './DailyTransaction';

const fieldSchema = {
    "range": [resolve.as(TransactionHistoryRange)],
    "dailyTransactions": [resolveAll.as(DailyTransaction)]
};

class TransactionHistoryResults extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(TransactionHistoryResults, json, getResolvers(fieldSchema));
    }
}

export default TransactionHistoryResults;
